import TimeAgo from 'javascript-time-ago';
import en from 'javascript-time-ago/locale/en';
import moment from 'moment';

export default {
  format: (dateInput, format) => {
    const date = new Date(dateInput);

    if (date.toString() === 'Invalid Date') {
      return '';
    }

    switch (format) {
      case 'dateTimeZone':
        return new Intl.DateTimeFormat('en-US', {
          year: 'numeric',
          month: 'short',
          day: 'numeric',
          hour: 'numeric',
          minute: 'numeric',
          timeZoneName: 'short'
        }).format(date);
      default:
        return dateInput;
    }
  },
  // timeAgo convert date to local relative date, default using en-US locale
  // expect UTC from server, e.g: `2019-09-05T05:49:20.168247827Z`:
  timeAgo: (dateInput) => {
    TimeAgo.addLocale(en);
    const timeAgo = new TimeAgo('en-US');
    return timeAgo.format(new Date(dateInput));
  },
  // get month ago time with format YYYY-MM-DD
  monthAgoFmt: () => {
    return moment()
      .set('month', moment().get('month') - 1)
      .format('YYYY-MM-DD');
  },
  // get tomorrow time with format YYYY-MM-DD
  tomorrowFmt: () => {
    return moment().add(1, 'days').format('YYYY-MM-DD');
  }
};
